import { getStoredRegion, setStoredRegion, toStoredRegion } from '../utils/region'
import { isProdEnvironment } from './environment'

const defaultSupportPalUrl = 'https://support.onepointcollab.com/portal-api/'
// Дев (console-dev): прослойка SupportPal, авторизація через Bearer токен Keycloak
const devSupportPalUrl = 'https://support.onepointcollab.com/portal-api/'
const defaultDocsUrl = 'https://docs.onecloudplanet.com/docs/'
const defaultDocsUrlUa = 'https://docs.onecloudplanet.com/docs/ua/'

const normalizeDocsUrl = (url: string | undefined, fallback: string, isUa = false) => {
  const rawDocsUrl = url && url !== 'undefined' ? url : fallback

  try {
    const docsUrl = new URL(rawDocsUrl)
    const pathname = docsUrl.pathname.replace(/\/+$/, '')

    if (!pathname) {
      docsUrl.pathname = isUa ? '/docs/ua/' : '/docs/'
    } else if (!pathname.startsWith('/docs')) {
      docsUrl.pathname = `/docs${pathname}/`
    } else if (isUa && pathname === '/docs') {
      docsUrl.pathname = '/docs/ua/'
    } else {
      docsUrl.pathname = `${pathname}/`
    }

    return docsUrl.toString()
  } catch {
    return rawDocsUrl.endsWith('/') ? rawDocsUrl : `${rawDocsUrl}/`
  }
}

const getDocsUrl = () => localStorage.getItem('lang') === 'uk'
  ? normalizeDocsUrl(process.env.REACT_APP_DOCS_URL_UA, defaultDocsUrlUa, true)
  : normalizeDocsUrl(process.env.REACT_APP_DOCS_URL, defaultDocsUrl)

const getInvitationRegionFromUrl = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const legacyInvitationRegion = searchParams.get('invite_region')

  if (legacyInvitationRegion) {
    return legacyInvitationRegion
  }

  if (window.location.pathname.includes('/invitation')) {
    return searchParams.get('region')
  }

  return null
}

const invitationRegion = getInvitationRegionFromUrl()
const currentRegion = invitationRegion && toStoredRegion(invitationRegion)
  ? setStoredRegion(invitationRegion)
  : getStoredRegion()

const devConfig = {
  tinyToken:process.env.REACT_APP_TINY_TOKEN,
  supportPalToken: process.env.REACT_APP_SUPPORT_PAL_TOKEN,
  supportPalUrl: process.env.REACT_APP_SUPPORT_URL || defaultSupportPalUrl,
  apiUrl: process.env.REACT_APP_API_DEV_URL || 'https://cp.netengi.com/backend/', 
  keycloakUrl:process.env.REACT_APP_KEYCLOAK_DEV_URL || 'https://auth.netengi.ua/auth',
  realmName: 'Onecloud',
  docs_url: getDocsUrl()
}

const prodConfig = {
  tinyToken:process.env.REACT_APP_TINY_TOKEN,
  supportPalToken: process.env.REACT_APP_SUPPORT_PAL_TOKEN,
  supportPalUrl: process.env.REACT_APP_SUPPORT_URL || defaultSupportPalUrl,
  apiUrl: currentRegion === 'nl-1' ? 'https://core-nl.ocplanet.cloud/backend/' : process.env.REACT_APP_API_PROD_URL || 'https://core.ocplanet.cloud/backend/',
  keycloakUrl:process.env.REACT_APP_KEYCLOAK_PROD_URL || 'https://auth.ocplanet.cloud/auth', 
  realmName: 'onecloud',
  docs_url: getDocsUrl()
}
const newConfig = {
  tinyToken:process.env.REACT_APP_TINY_TOKEN,
  supportPalUrl: devSupportPalUrl,
  // apiUrl: 'https://bill.10support.com/backend/',
  apiUrl: 'https://api.dev.ocplanet.cloud/backend/',
  // apiUrl: process.env.REACT_APP_API_URL,
  keycloakUrl:'https://auth.netengi.ua/auth', 
  realmName: 'Onecloud',
  docs_url: getDocsUrl()
}
const rootConfig = isProdEnvironment ? prodConfig : newConfig

export default rootConfig
